<template>
  <div class="form__group field">
    <div class="form-check">
      <label for="pp" class="form-check-label">
          <input id="pp" name="pp" v-model="accepted" type="checkbox" class="form-check-input">
          Ich habe die <a :href="privacyNoticeUrl" target="_blank">Hinweise zum Datenschutz</a> gelesen und akzeptiere diese.
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pnUrl", "ppAccepted"],
  data() {
    return {
      accepted: this.ppAccepted,
      privacyNoticeUrl: this.pnUrl,
    };
  },
  watch: {
    accepted() {
      this.$emit("update:ppAccepted", this.accepted);
    }
  }
};
</script>
